<template>
  <div class="project-mutate-sale">
    <Tabs
      theme="border"
      v-model="saleType"
      :items="[
        { id: 'self', label: $t('residentialSaleSelf') },
        { id: 'broker', label: $t('residentialSaleWithBroker') },
      ]"
    >
      <template #self>
        <Paywall
          :value="addons"
          items="project:bid"
          :options="{ units }"
          :action="addon => $store.dispatch('Project/addon', { addon, state: true })"
          class="project-mutate-sale__input"
        >
          <template #default>
            <div data-field="contractTemplates.bid">
              <TemplateUpload v-model="value.contractTemplates.bid" :label="labels.bidContract" />
            </div>
            <FileComponent
              v-model="value.contractTemplates.bidAttachments"
              data-field="contractTemplates.bidAttachments"
              :label="`${$tc('attachment', 2)} (${labels.bidContract})`"
              accept=".pdf"
              multiple
            >
              <template #below>
                <Alert class="mt-1">
                  <div>{{ $t('attachmentsSigningUploadWarning') }}</div>
                </Alert>
              </template>
            </FileComponent>
          </template>
        </Paywall>
      </template>
      <template #broker>
        <UpsellBanner
          :title="$t('broker-integration-banner-title')"
          :description="$t('broker-integration-banner-description')"
          :action="$t('gotoItem', [$tc('integration', 2).toLowerCase()])"
          @action="$router.push({ params: { step: 'integrations' }, query: { category: 'brokerage' } })"
        />
      </template>
    </Tabs>

    <UpsellBanner
      v-if="showSettlementBanner"
      title="Trenger du bistand med oppgjør?"
      action="Gå til integrasjoner"
      @action="$router.push({ params: { step: 'integrations' }, query: { category: 'settlement' } })"
      class="mt-2"
    >
      <template #description>
        <span
          >Kvass sitt samarbeid med Bolignett og Weboppgjør skaper grunnlag for en kundevennlig og effektiv salgs- og
          oppgjørsprosess. Dette er noe som skaper verdi både for selger og kjøper i nyboligprosjekter -
        </span>
        <a href="https://help.kvass.no/nb/articles/71774-bolignett" target="_blank">Les mer</a>
      </template>
    </UpsellBanner>

    <CustomFields
      v-model="value.customFields"
      :schema="customFieldSchemas"
      :data="data"
      :placement="['sale', 'project:sale']"
      :validator="validator"
      validator-prefix="customFields"
      :disabledFields="$path('metadata.disabledFields.project', item)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'

import { FileComponent } from '@kvass/file'
import { AlertComponent as Alert } from 'vue-elder-alert'
import CustomFields from '@kvass/custom-fields'
import Pricing from '@/components/Pricing'
import { Upsell, Paywall, Banner as UpsellBanner } from '@/components/Upsell'
import FileOnDrop from '@/components/vendors/kvass-file/onDrop'
import Tabs from '@/components/Tabs'
import TemplateUpload from '@/components/Contract/TemplateUpload'

const meta = {
  order: 1001,
  id: 'sale',
  label: i18n.tc('sale'),
  icon: ['fal', 'sign'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    data: Object,
    isActive: Boolean,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
  },
  data() {
    return {
      saleType: 'self',
    }
  },
  computed: {
    ...mapState('Project', {
      item: 'item',
      addons(state) {
        return this.$path('item.metadata.addons', state) || []
      },
      units(state) {
        return this.$path('item.metadata.limits.units', state)
      },
      showSettlementBanner() {
        return (
          this.saleType === 'self' && !(this.$path('item.metadata.integrations') || []).includes('preset/bolignett')
        )
      },
    }),
  },
  components: {
    FileComponent,
    Alert,
    Paywall,
    CustomFields,
    FileOnDrop,
    Pricing,
    Upsell,
    UpsellBanner,
    Tabs,
    TemplateUpload,
  },
}
</script>

<style lang="scss">
.project-mutate-sale {
  max-width: 1100px;

  &__input {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: $form-gap;
  }

  .tabs {
    &__details {
      border: none !important;
      box-shadow: var(--box-shadow);
    }

    &__header {
      ul,
      a {
        border: none !important;
      }

      a {
        background-color: rgba(black, 0.03);
      }

      &--active a {
        background-color: White;
      }
    }
  }

  [data-id='broker'] .upsell-banner {
    background: transparent;
    color: inherit;
    box-shadow: none;

    .card__content {
      padding: 0;
    }
  }
}
</style>
